/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Esteban's Portfolio",
  description:
    "A passionate individual who constantly facing challenges. Motivated by continuous learning to create impact and reach their dreams.",
  og: {
    title: "Esteban Carvallo Portfolio",
    type: "website",
    url: "http://ecarvallo.github.io/",
  },
};

//Home Page
// portfolio_repository -> drive w/resume.
const greeting = {
  title: "Esteban Carvallo",
  logo_name: "Esteban Carvallo",
  nickname: "Hi! I am <ecarvallo/>",
  subTitle:
    "A passionate individual who constantly facing challenges. Motivated by continuous learning to create impact and reach their dreams.",
  resumeLink:
    "https://drive.google.com/file/d/1FhGwcQ3G_mVfmEqwEQrSjmIZgKdrZM7h/view?usp=sharing",
  portfolio_repository: "https://drive.google.com/file/d/1KcjuFjKq2e1546a72JUdCDPKiIt0YIvq/view?usp=share_link",
  githubProfile: "https://github.com/ecarvallo777",
};

const socialMediaLinks = [

  {
    name: "Github",
    link: "https://github.com/ecarvallo777",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/esteban-carvallo-fuentes-555697195/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:ecarvallo16@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },

];

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front end using Vanilla Javascript and React",
        "⚡ Creating application backend in Node, Django and PHP",
        "⚡ Developing for Perfomance",

      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        
        {
          skillName: "SQL",
          fontAwesomeClassname: "fa-database",
          style: {
            color: "#1572B6",
          },
        },
      
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "Django",
          fontAwesomeClassname: "simple-icons:django",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "PHP",
          fontAwesomeClassname: "simple-icons:php",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        
        
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/ecarvallo16/",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "University of Talca",
      subtitle: "Ingeniería en Informática Empresarial",
      logo_path: "utalca.svg",
      alt_name: "University of Talca",
      duration: "2016 - 2022",
      descriptions: [
        "⚡ I have taken varity of courses related to programming foundaments and business management.",
      ],
      website_link: "https://www.utalca.cl/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Javascript Dev",
      subtitle: "LinkedIn Learning",
      logo_path: "linkedin.svg",
      certificate_link:
        "https://linkedin.com/learning/certificates/f3080c2bd6e6e8641dbb8f108c605f83812fa4fada0a617acfba71479162289f",
      alt_name: "javascript",
      color_code: "#1F70C199",
    },
    {
      title: "English B2",
      subtitle: "TOEFL iBT",
      logo_path: "b.svg",
      certificate_link:
        "https://drive.google.com/file/d/1xbN7dFVVuyYy84buEkcsN61RvJO6VM1D/view?usp=share_link",
      alt_name: "english",
      color_code: "#D83B0199",
    }
    
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Support and Maintenance Engineer",
          company: "Bolsa de Santiago",
          company_url: "https://bolsadesantiago.com/",
          logo_path: "bolsaSantiago.png",
          duration: "April 2023 - Today",
          location: "Remote",
          description:
            "",
          color: "#0879bf",
        },
        
      ],
    },
    {
      title: "Internships",
      experiences: [
        // {
        //   title: "Machine Learning Intern",
        //   company: "TikTok Inc.",
        //   company_url: "https://www.tiktok.com/en/",
        //   logo_path: "tiktok_logo.png",
        //   duration: "May 2022 - Aug 2022",
        //   location: "San Francisco, USA",
        //   description:
        //     "Building new features on the backend recommendation system, specifically ranking algorithms for Ads that touch hundreds of millions of people around the world. Improving online and offline content ranking algorithms by performing hard sample data replays for training steps.",
        //   color: "#000000",
        // },
        
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        // {
        //   title: "Google Explore ML Facilitator",
        //   company: "Google",
        //   company_url: "https://about.google/",
        //   logo_path: "google_logo.png",
        //   duration: "June 2019 - April 2020",
        //   location: "Hyderabad, Telangana",
        //   description:
        //     "Explore Machine Learning (ML) is a Google-sponsored program for university students to get started with Machine Learning. The curriculum offers 3 tracks of ML Content (Beginner, Intermediate, Advanced) and relies on university student facilitators to train other students on campus and to build opensource projects under this program.",
        //   color: "#4285F4",
        // },
        
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create projects for entrepreneurs and solve programming problems.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  // title: "Publications",
  // description:
  //   "I have worked on and published a few research papers and publications of my own.",
  // avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    // {
    //   id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=",
    //   name: "Artificial Intelligence Paper",
    //   createdAt: "2020-03-06T16:26:54Z",
    //   description: "Paper Written on Artificial Intelligence published in xyz ",
    //   url:
    //     "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    // },
    
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "image.webp",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. ",
  },
  blogSection: {
    // title: "Blogs",
    // subtitle:
    //   "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
    // link: "https://blogs.ashutoshhathidara.com/",
    // avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
  //   title: "Address",
  //   subtitle:
  //     "Ambavadi vas, Kanodar, T.A.-Palanpur, Dist.-Banaskantha, Gujarat - 385520",
  //   avatar_image_path: "address_image.svg",
  //   location_map_link: "https://goo.gl/maps/MpMqtRZytFchMkZ76",
  // },
  // phoneSection: {
  //   title: "",
  //   subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
